import React from "react";
import General from "../../stores/GeneralStore";
import PDFICON from "../../../src/assets/Home/PDFICON.svg";
import { observer } from "mobx-react";
import DeLinkAccountModal from './DeLinkAccount';
import { useState, useEffect } from "react";
import { DELINK } from "./../NOC.Tabs/Noc.styled";
import Modal from "@mui/material/Modal";

const AccountsGridMobile = ({ rowsss, loadTable, dowmloadPDF }) => {

  const [accountNo, setAccountNo] = useState('');
  const [deLinkModal, setDeLinkModal] = useState(false);
  return (
    <div className="px-3 " style={{ height: "87vh", overflowY: "scroll" , position:'relative' }}>
      {rowsss.map((rowsss) => {
        return (
          <div className=" row d-flex justify-content-between my-3">
            <div className="col-4">
              <div>
                <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_accountnobillstable"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_accountnobillstable"]?.label
                    : "Account Number"}
                </p>
                <p
                  className="mb-0 account-grid-mobile-text"
                  style={{
                    fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                    lineHeight: "23px",
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {" "}
                  {rowsss.accountNumber}{" "}
                </p>
              </div>
              <div className="">
                <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                    lineHeight: "23px",
                  }}
                >
                  {" "}
                  {General?.codeLabels["cm_premiseid"]?.label !== undefined
                    ? General?.codeLabels["cm_premiseid"]?.label
                    : "Sewerage Number"}
                </p>
                <p
                  className="mb-0 account-grid-mobile-text"
                  style={{
                    fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                    lineHeight: "23px",
                  }}
                >
                  {" "}
                  {rowsss.sewerageNumber}{" "}
                </p>
              </div>
              <div>
              
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_delink"]?.label !== undefined
                        ? General?.codeLabels["cm_delink"]?.label
                        : "Delink Property"}
                    </p>
                    {rowsss.localType == "con" ? (
              <div onClick={() => {
                setAccountNo(rowsss?.sewerageNumber)
                setDeLinkModal(true)
              }}>
                <DELINK
                  style={{
                    backgroundColor: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : General.ColorAss,
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : "#fff",
                      border:"none",
                      width:"350px",
                  }}
                >
                  {General?.codeLabels["cm_delink_pd"]?.label ? General?.codeLabels["cm_delink_pd"]?.label : "DELINK"}
                </DELINK>
              </div>
            ) : null}
                  </div>
              </div>
            </div>

            <div className="col-4">
              <div>
                <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {" "}
                  {General?.codeLabels["cm_dpremisedetails"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_dpremisedetails"]?.label
                    : "Premise Details"}
                </p>
                <p
                  className="mb-0 account-grid-mobile-text"
                  style={{
                    lineHeight: "23px",
                    fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {" "}
                  {rowsss.premiseDetails}{" "}
                </p>
              </div>
              <div>
                <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {" "}
                  {General?.codeLabels["cm_premise_type"]?.label !== undefined
                    ? General?.codeLabels["cm_premise_type"]?.label
                    : "Premise Type"}
                </p>
                <p
                  className="mb-0 account-grid-mobile-text"
                  style={{
                    lineHeight: "23px",
                    fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {" "}
                  {rowsss.premiseType}{" "}
                </p>
              </div>
            </div>

            <div className="col-4">
              <div>
                <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_customername"]?.label !== undefined
                    ? General?.codeLabels["cm_customername"]?.label
                    : "Customer Name"}
                </p>
                <p
                  className="mb-0 account-grid-mobile-text"
                  style={{
                    lineHeight: "23px",
                    fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,
                  }}
                >
                  {" "}
                  {rowsss.customerName}{" "}
                </p>
              </div>

              <div>
                <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    :General.ColorAss,

                    lineHeight: "23px",
                  }}
                >
                  {" "}
                  {General?.codeLabels["cm_last_bill"]?.label !== undefined
                    ? General?.codeLabels["cm_last_bill"]?.label
                    : "Last Bill"}{" "}
                </p>
                <div className="">
                  <img 
                  src={PDFICON} 
                  onClick={() => dowmloadPDF(rowsss.accountNumber)}
                  alt="pdf" />
                </div>
              </div>
            </div>

            <hr />
          </div>
        );
      })}

      <Modal
        open={deLinkModal}
        onClose={() => setDeLinkModal(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DeLinkAccountModal accountNo={accountNo} getUser={loadTable} onCross={() => setDeLinkModal(false)} />
      </Modal>
    </div>
  );
};

export default observer(AccountsGridMobile);

